import { gql } from '@grandvisionhq/graphql';
import { cartDetails } from '../fragments/cart-details.js';
import { cartValidationErrors } from '../fragments/cart-validation-errors.js';

const GET_CART = gql`
  query GetCart($id: ID!) {
    getCart(id: $id) {
      cart {
        ...CartDetailsFragment
      }
      validationErrors {
        ...CartValidationErrorsFragment
      }
    }
  }
  ${cartDetails}
  ${cartValidationErrors}
`;

export { GET_CART };
//# sourceMappingURL=get-cart.js.map
